import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import * as aserver from '../../APIClient';
import { withStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Redirect } from "react-router-dom";
import Modal from '../comps/modal';
import * as utils from '../../Utilities'
import Logo from "../images/Aephoria-logo-blue-login.png"
import leaf from "../images/Leaf.png"

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://aephoriagroup.com/">
      Aephoria Partners      
      </Link>{' '}
      {new Date().getFullYear()}
    </Typography>
  );
}

const CustomTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#6699C9',
      },
      '&:hover fieldset': {
        borderColor: '#6699C9',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#6699C9',
      },
    },
  },
})(TextField);

const useStyles = theme => ({
  root: {
    height: '100vh',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}); 

class Login extends React.Component {

 constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      loginErrors: "",
      showPassword: false,
      modalIsOpen:false,
      emailAddress:"",
      disableResetSendButton: true,
      authenticatorCode:"",
      headingTitle:""
    };
    this.authenticatorInputRef = React.createRef();
  }

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleChange =(event)=>{
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  validateEmail =(event)=> {
    this.setState({
      [event.target.name]: event.target.value
    });
    if (utils.validateEmail(event.target.value)) {
      this.setState({
        disableResetSendButton:false
      })
     } else {
      this.setState({
        disableResetSendButton:true
      })
    }
  }

  forgetPassword=(headingTitle, modalText)=>{
    this.setState({
      modalIsOpen:true,
      headingTitle:headingTitle,
      modalText: modalText
    })
  }

sendResetLink= async()=>{
  this.setState({
    disableResetSendButton: true,
  })
  let sendResetLink = await aserver.post(`api/v2/forgotpassword`,{
    email: this.state.emailAddress
  });
  if(sendResetLink.status === 200){
    alert(`A reset password link has been sent to the email address provided. Follow the link in the email to reset your password.
    
If you do not get the email, make sure the address you provided is the one linked to your coach portal account.`)
  }else{
    alert('There was an error with sending. Please check if the email address is correct, or try again later.')
  }
  this.closeModal()
}

escFunction = (event) => {
  if (event.keyCode === 27) {
    this.closeModal()
  }
}

closeModal = () => {
  this.setState({
    modalIsOpen: false,
    emailAddress:"",
  });
}

handleEnterKeyPress = (event) => {
  if (event.key === 'Enter' && !this.state.disableResetSendButton) {
    event.preventDefault();
    this.sendResetLink();
  }
};

  handleSubmit =async(event)=> {
    event.preventDefault();
    const { email, password, authenticatorCode } = this.state;
    let results = await aserver.post('api/v2/login',
        {
        email: email,
        password: password,
        twoFactorToken: authenticatorCode
        });
    if ((!results.data.allowed) && results.data.message) {
      alert(results.data.message)
      return;
    }
              if (results.data.allowed) {
          utils.writeCoachDetailsToLocalStorage(results, false)
          aserver.goto('/coachportal/dashboard');
      }else if(!results.data.allowed && results.data.needTFA){
        this.setState({
          showAuthenticatorInput:true
        })
      }
      else if(!results.data.allowed && results.data.wrongTFA){
        alert('Code incorrect - please try again.')
      }
      else if(results.data.isBlocked){
        alert('You have been blocked. Please contact hello@aephoriagroup.com to get access to your account again.')
      }else{
        alert("Please check if password and username are correct")
      }   
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showAuthenticatorInput && !prevState.showAuthenticatorInput) {
      this.authenticatorInputRef.current.focus();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  renderContent = () => {
    const { classes } = this.props;
    return  <Grid container component="main" className={classes.root}>
    <CssBaseline />
    <Grid item xs={false} sm={false} md={6} className="leftHandSide LeftImage">
      <img item xs={false} sm={false} className='mainLoginImage' src={Logo} alt="aephoria-logo"/> 
      <img  item xs={false} sm={false} className='leafLoginImage' src={leaf} alt="aephoria-logo"/>
    </Grid>
    <Grid className='loginGrid' item xs={12} sm={12} md={6} component={Paper} elevation={6} square>
      
      <div className='login-paper'>
      <img className='loginImage' style={{display:"none"}} src={Logo} alt="aephoria-logo"/>
      <h1 className="loginHeading" style={{textAlign:"center", textTransform:"capitalize"}}>Coach Portal</h1>


        <form className={classes.form} noValidate onSubmit={this.handleSubmit}>
          <div style={{display: this.state.showAuthenticatorInput?"none":"block"}}>
            <CustomTextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={this.state.email}
              onChange={this.handleChange}
            />
            <CustomTextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={this.state.showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              value={this.state.password}
              onChange={this.handleChange}
              InputProps={{
                endAdornment:(
                <InputAdornment position="end" >
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
                </InputAdornment>
                )
              }}
            />
          </div>
          <div style={{display: this.state.showAuthenticatorInput?"block":"none"}}>  
            <h2>Authenticate your account</h2>      
            <p>Your account has two-factor authentication enabled. Please confirm your account by entering the code generated by your authenticator app.</p>
            <CustomTextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            style={{display:this.state.showAuthenticatorInput?"block":"none"}}
            name="authenticatorCode"
            label="authenticator Code"
            type='text'
            id="authenticatorCode"
            inputRef={this.authenticatorInputRef} 
            onChange={this.handleChange}/>
          </div>  
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            d disabled={
              !this.state.email || 
              !this.state.password || 
              (this.state.showAuthenticatorInput && !this.state.authenticatorCode)
            }
          >
            Sign In
          </Button>
          <br></br>
          <p onClick={()=>this.forgetPassword("Forgot Password?",<>
            Don't worry. Resetting your password is easy,<br/>
            just tell us the email address you registered with us.
            </>)} style={{cursor:"pointer"}}><u>Forgot Password?</u>
          </p>
          <p onClick={()=>this.forgetPassword("New Account?", <>To set your password for your new coach portal account,<br/> please provide the email address linked to the account.</>)} style={{cursor:"pointer"}}><u>New Account?</u></p>
        </form>
          <Modal isOpen={this.state.modalIsOpen} onClose={() => this.closeModal()}>
            <br></br>
            <h3>{this.state.headingTitle}</h3>
            <p>{this.state.modalText}</p>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="emailAddress"
              label="Email Address"
              name="emailAddress"
              autoComplete="email"
              autoFocus
              value={this.state.emailAddress}
              onChange={this.validateEmail}
              onKeyPress={this.handleEnterKeyPress}
            />
            <br></br>
            <Button 
              variant="contained"
              color="primary"
              onClick={this.sendResetLink}
              disabled={this.state.disableResetSendButton}
              >
                Send Reset Link
            </Button>
          </Modal>
      </div>
            <Copyright />
    </Grid>
  </Grid>
  }
  
  render() {
  if (localStorage.getItem("Id")) { // if Id exists, coach is logged in
      return <Redirect to="/coachportal/dashboard" />;
  }

  return this.renderContent()
  }
}

export default withStyles(useStyles, { withTheme: true })(Login)